import {
  STORE_ITEMS, OPEN_ADD_MODAL, CLOSE_ADD_MODAL, OPEN_EDIT_MODAL, UPDATE_ITEM,
  CLOSE_EDIT_MODAL, OPEN_DELETE_MODAL, CLOSE_DELETE_MODAL, RESET_STATE, DELETE_ITEM, FINISH_PENDING,
  SUBMIT_UPDATE_ITEM, SUBMIT_ADD_ITEM, SUBMIT_DELETE_ITEM, LOAD_MORE,
} from '../actions/actionTypes';

const initState = {
  isPending: true,
  isLoadingMore: true,
  byId: {},
  allIds: [],
  nextPageCursor: '',
  didInvalidate: false,
  isAddModalOpen: false,
  validation: {
    isError: false,
    message: '',
  },
  isPendingAdd: false,
  isPendingUpdate: false,
  isPendingDelete: false,
};

const snukReducer = (state = initState, action, callerReducerName) => {
  if (!action || action.reducerName !== callerReducerName) {
    return state;
  }

  switch (action.type) {
    case STORE_ITEMS: {
      const { payload } = action;
      const itemsById = payload.data.entities[payload.itemsName];
      const itemsAllIds = payload.data.result;
      const items = {};
      itemsAllIds.forEach((id) => {
        items[id] = {
          ...itemsById[id],
          // isEditModalOpen: false,
          // isDeleteModalOpen: false,
        };
      });
      return {
        ...state,
        isPending: false,
        isLoadingMore: false,
        isPendingAdd: false,
        byId: { ...state.byId, ...items },
        allIds: [...state.allIds, ...payload.data.result],
        nextPageCursor: payload.data.nextPageCursor || '',
      };
    }
    case LOAD_MORE: {
      return { ...state, isLoadingMore: true };
    }
    case OPEN_ADD_MODAL:
    case CLOSE_ADD_MODAL: {
      return {
        ...state,
        isPendingAdd: false,
        isAddModalOpen: action.type === OPEN_ADD_MODAL,
      };
    }
    case OPEN_EDIT_MODAL:
    case CLOSE_EDIT_MODAL: {
      const { id } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: {
            ...state.byId[id],
            isEditModalOpen: action.type === OPEN_EDIT_MODAL,
          },
        },
      };
    }
    case OPEN_DELETE_MODAL:
    case CLOSE_DELETE_MODAL: {
      const { id } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: {
            ...state.byId[id],
            isDeleteModalOpen: action.type === OPEN_DELETE_MODAL,
          },
        },
      };
    }
    case SUBMIT_ADD_ITEM: {
      return {
        ...state,
        isPendingAdd: true,
      };
    }
    case SUBMIT_UPDATE_ITEM: {
      return {
        ...state,
        isPendingUpdate: true,
      };
    }
    case UPDATE_ITEM: {
      const { data, itemsName } = action.payload;
      const itemsById = data.entities[itemsName];
      const byId = {
        ...state.byId,
        ...itemsById,
      };

      return {
        ...state,
        byId,
        isPendingUpdate: false,
      };
    }
    case SUBMIT_DELETE_ITEM: {
      return {
        ...state,
        isPendingDelete: true,
      };
    }
    case DELETE_ITEM: {
      const { id } = action.payload;
      const byId = { ...state.byId };
      delete byId[id];

      return {
        ...state,
        allIds: state.allIds.filter(idx => idx !== id),
        byId,
        isPendingDelete: false,
      };
    }
    case FINISH_PENDING: {
      return {
        ...state,
        isPending: false,
      };
    }
    case RESET_STATE:
      return initState;
    default:
      return state;
  }
};

export default snukReducer;



// WEBPACK FOOTER //
// ./src/reducers/snukReducer.js